import React, { useEffect, useState } from 'react'

import LoadingSpinner from '../Spinners/LoadingSpinner'

/**
 * Delayed loading spinner for lazy-loaded routes
 * Only shows spinner if loading takes longer than the delay threshold
 * Prevents flash of loading state for fast loads
 */
const DelayedSpinner: React.FC<{ delay?: number }> = ({ delay = 200 }) => {
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(true)
    }, delay)

    return () => clearTimeout(timer)
  }, [delay])

  return showSpinner ? <LoadingSpinner loading={true} /> : null
}

export default DelayedSpinner
